<template>
    <div id="loader">
        <div class="loader">
            <div class="dot dot1"></div>
            <div class="dot dot2"></div>
            <div class="dot dot3"></div>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style scoped>
.loader {
    display: flex;
    align-items: center;
    justify-content: center;
}

.dot {
    width: 20px;
    height: 20px;
    background-color: #25AD34;
    border-radius: 50%;
    margin: 0 5px;
    animation: wave 1.5s infinite ease-in-out;
}

.dot1 {
    animation-delay: 0.2s;
}

.dot2 {
    animation-delay: 0.4s;
}

.dot3 {
    animation-delay: 0.6s;
}

@keyframes wave {
    0%, 60%, 100% {
        transform: translateY(0);
    }
    30% {
        transform: translateY(-15px);
    }
}
</style>